export default __webpack_public_path__ + "static/media/developmentIcon.615f1c64.png";